import React from 'react'
import { CateringIcon } from './CateringIcon'
import { DiversityAndInclusionIcon } from './DiversityAndInclusionIcon'
import { VenueSustainableInitiativesSustainabilityInitiativeFragment } from '../VenueSustainableInitiatives.generated-types'
import { EnergyIcon } from './EnergyIcon'
import { PoliciesAndCredentialsIcon } from './PoliciesAndCredentialsIcon'
import { PurchasingIcon } from './PurchasingIcon'
import { TravelIcon } from './TravelIcon'
import { WasteAndRecylingIcon } from './WasteAndRecyclingIcon'
import { WaterIcon } from './WaterIcon'

export const sustainabilityInitiativeCategoriesToIcons: Record<
VenueSustainableInitiativesSustainabilityInitiativeFragment['category'],
JSX.Element
> = {
  CATERING: <CateringIcon />,
  DIVERSITY_AND_INCLUSION: <DiversityAndInclusionIcon />,
  ENERGY: <EnergyIcon />,
  POLICIES_AND_CREDENTIALS: <PoliciesAndCredentialsIcon />,
  PURCHASING: <PurchasingIcon />,
  TRAVEL: <TravelIcon />,
  WASTE_AND_RECYCLING: <WasteAndRecylingIcon />,
  WATER: <WaterIcon />,
}
